import React from 'react';

import { Page } from '../../../../../shared/ui/Page';
import { SupportEditContainer } from '../containers/SupportEditContainer';

export const SupportEditPage = () => {
    return (
        <Page isBackButton title={'Чат поддержки'}>
            <SupportEditContainer />
        </Page>
    );
};
